// extracted by mini-css-extract-plugin
export default {"container":"ContentCenter_container__KrSoo"};